// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__M0KNN"};